import React from 'react';
import { Button } from '@atoms/Button/Button';
import { CaretLeft } from '@phosphor-icons/react';

interface ErrorPageProps {
  errorHeader: string;
  errorInfo?: string | React.ReactNode;
  navButtonLabel?: string;
  navigateTo?: () => void;
}

/**
 * This error page will display upon redirecting to the path that doesn't exist
 */
export const ErrorPage = ({
  errorHeader,
  errorInfo,
  navButtonLabel,
  navigateTo,
}: ErrorPageProps) => {
  return (
    <>
      <h1 className="text-h2 text-brand-primary mt-[1.5rem]">{errorHeader}</h1>
      <hr className="border-ui-border my-[2.125rem] w-full border-[1px] opacity-25" />
      <div className="errorInformation mt-[27px] w-full">
        {errorInfo ? errorInfo : null}
      </div>
      {navButtonLabel && navigateTo ? (
        <div className="mt-10 flex items-start">
          <Button
            variant="primary"
            label={navButtonLabel}
            onClick={navigateTo}
            iconLeft={<CaretLeft />}
          />
        </div>
      ) : null}
    </>
  );
};
